import React from "react"
import { SimpleGrid, GridItem } from "@chakra-ui/react"

export default function AccountLayout({ gradientBox, message }) {
  return (
    <SimpleGrid columns={[1, 1, 10]} minHeight="100vh">
      <GridItem
        colSpan={{ base: 1, md: 6 }}
        minH={{ base: "80vh", md: "100%" }}
      >
        {gradientBox}
      </GridItem>
      <GridItem
        colSpan={{ base: 1, md: 4 }}
        minH={{ base: "80vh", md: "100%" }}
      >
        {message}
      </GridItem>
    </SimpleGrid>
  )
}
